import {
  resolveProgressStatus,
  isError,
  isLoaded
} from '../../lib/progressStatus'

// Action Types
export const Types = {
  RESET: 'SPREAD_THEME/RESET',
  SET_S3_PATH: 'SPREAD_THEME/SET_S3_PATH',
  SET_ERROR: 'SPREAD_THEME/SET_ERROR'
}

// Reducer
const initialState = {
  s3Path: undefined,
  error: false,
  loaded: false
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case Types.SET_S3_PATH: {
      const status = resolveProgressStatus(action.payload)

      return {
        ...state,
        s3Path: action.payload,
        loaded: isLoaded(status),
        error: isError(status)
      }
    }
    case Types.SET_ERROR:
      return {
        ...state,
        s3Path: action.payload,
        error: true,
        loaded: true
      }
    case Types.RESET:
      return initialState
    default:
      return state
  }
}

// Action Creators
export function setErrorSpread (data) {
  return {
    type: Types.SET_ERROR,
    payload: data
  }
}

export function setS3PathSpread (data) {
  return {
    type: Types.SET_S3_PATH,
    payload: data
  }
}

export function resetSpreadTheme () {
  return {
    type: Types.RESET
  }
}
